import { observable, action, makeObservable } from "mobx";
class Base {
  constructor() {
    makeObservable(this);
  }
  @observable i18nLang = "en";

  @action
  setLang(value = "zh") {
    this.i18nLang = value;
    sessionStorage.setItem("i18nLang", value);
  }
}
export default new Base();
